// @flow

import { type Validation } from './types';

export function hasUserInputValidationError(validation: Validation): boolean {
  if (validation.userInputValidationErrors) {
    return Object.values(validation.userInputValidationErrors).some(item => !!item);
  }
  return false;
}
